import React from "react";
import { AnimatePresence } from "framer-motion";
import AppRoutes from "../src/routes/routes";
import { useLocation } from "react-router-dom";
import "./responsive.css";

const App = () => {
  const location = useLocation();

  
  return (
    <AnimatePresence mode="wait" initial={false}>
      <AppRoutes key={location.pathname} />
    </AnimatePresence>
  );
};

export default App;
